import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../../intl/TranslatedCopy';
import StatusToolTip from '../returnStatus/StatusToolTip';
import { H1, Icon, SpacerDot } from '../../components';

const ReturnDetailsHeader = ({ returnId, status, totalProducts, onDownloadClicked, onPrintClicked }) => (
  <div className='returnDetails__headerWrap u-full-width ta-sm-c ta-md-l'>
    <div className='returnDetails__headerTitle'>
      <H1>
        <TranslatedCopy id='returnDetails.return' /> {returnId}
      </H1>
      <p className='body-3'>
        {totalProducts} <TranslatedCopy id='global.items' />
        <span className='d-sm-ib d-md-h'>
          <SpacerDot />
          {status && <TranslatedCopy id={`returnStatus.returnStatus.${status.toLowerCase()}`} noWrap />}
        </span>
      </p>
    </div>
    <div className='returnDetails__headerNav d-sm-h d-md-b'>
      <div className='flex-container row' style={{ alignItems: 'center', fontSize: '12px' }}>
        <StatusToolTip />
        <p className='body-3 ml2-sm mb2-sm'>
          {status && <TranslatedCopy id={`returnStatus.returnStatus.${status.toLowerCase()}`} />}
        </p>
      </div>
      <div className='u-full-width ta-sm-r'>
        <Icon
          className='mr6-sm'
          name='download'
          alt={new TranslatedCopy({ id: 'orderreturns.report.download' }).toString()}
          onClick={onDownloadClicked}
        />
        <Icon
          name='print'
          alt={new TranslatedCopy({ id: 'orderreturns.report.print' }).toString()}
          onClick={onPrintClicked}
        />
      </div>
    </div>
  </div>
);

ReturnDetailsHeader.defaultProps = {
  returnId: null,
  status: null,
  totalProducts: null
};

ReturnDetailsHeader.propTypes = {
  returnId: PropTypes.string,
  totalProducts: PropTypes.number,
  status: PropTypes.string,
  onPrintClicked: PropTypes.func.isRequired,
  onDownloadClicked: PropTypes.func.isRequired
};

export default ReturnDetailsHeader;
